import { type FC } from "react";
import { Link } from "react-router";

import { DateTime } from "luxon";

import { BasicLink } from "./basic_link";

export const Copyright: FC = () => (
  <div className="flex flex-col gap-4">
    <nav>
      <ul className="flex justify-center gap-4">
        <li>
          <BasicLink to="/login">Login</BasicLink>
        </li>
        <li>
          <BasicLink to="/signup">Signup</BasicLink>
        </li>
        <li>
          <a href="/blog" className="link">
            Blog
          </a>
        </li>
        <li>
          <a href="/legal/privacy-policy" className="link">
            Privacy Policy
          </a>
        </li>
        <li>
          <a href="/legal/terms-of-service" className="link">
            Terms of Service
          </a>
        </li>
      </ul>
    </nav>
    <p className="text-center text-slate-600">
      © {DateTime.local().year} <Link to={"/"}>workflow.ing</Link>
    </p>
  </div>
);
